import {
  BaseTemplate as BaseBaseTemplate,
  FlexBox,
} from '@airship-platform/jam-web/components';
import { LeftArrowIcon, MenuIcon } from '@airship-platform/jam-web/icons';
import EnvironmentBanner from './EnvironmentBanner';
import NavBar from './NavBar';

interface BaseTemplateProps {
  navBarProps?: {
    hideNavbar?: boolean;
    defaultOpen?: boolean;
  };
  additionalBanner?: React.ReactNode;
}

const BaseTemplate: React.FC<BaseTemplateProps> = ({
  navBarProps,
  additionalBanner,
}) => (
  <BaseBaseTemplate
    navBarProps={navBarProps}
    navBar={({ isOpen, setIsOpen }) => (
      <NavBar isOpen={isOpen} setIsOpen={setIsOpen} />
    )}
    environmentBanner={
      <FlexBox gap={1} alignItems="center">
        {additionalBanner}
        <EnvironmentBanner />
      </FlexBox>
    }
    menuIcon={<MenuIcon />}
    collapseIcon={<LeftArrowIcon height={'24px'} width={'25px'} />}
  />
);

export default BaseTemplate;
